// BASE_URL に /api/v1 が含まれるため、相対パスは /user/features
// 納品実績一覧メニューの表示可否（canViewShipmentList）を返す（TB-1642 / PBI-207・BE design (B)）
export const getUserFeaturesEndpoint = '/user/features' as const
